import React from 'react'
import { useSelector } from 'react-redux'
import emptyFolder from 'assets/empty_folder.png'
import emptySpam from 'assets/empty_spam.png'
import emptyTrash from 'assets/empty_trash.png'
import StartContent from 'components/StartContent'
import { selectLeftNavFolderById } from 'selectors/left_nav'
import SearchBar from './LayoutSwitcher/ClassicView/TicketListPane/SearchBar'
import { styles } from './styles'

const emptyContent = {
  Trash: {
    title: 'No trash here!',
    subtitle: '',
    imgSrc: emptyTrash,
  },
  Spam: {
    title: 'No spam here!',
    subtitle: '',
    imgSrc: emptySpam,
  },
  Other: {
    title: 'This folder is empty',
    subtitle: 'Time to put your feet up and relax for a bit.',
    imgSrc: emptyFolder,
  },
}

const EmptyFolder = ({ showSearch, folderId = '' }) => {
  const currentFolder = useSelector(state =>
    selectLeftNavFolderById(state, folderId)
  )
  const content = emptyContent[currentFolder?.name] || emptyContent.Other
  return (
    <div css={styles.emptyFolderContainer}>
      {showSearch && <SearchBar />}
      <div css={styles.innerContainer}>
        <div css={styles.imgWrapper}>
          <img src={content.imgSrc} alt="empty" />
        </div>
        <StartContent
          title={content.title}
          subtitle={content.subtitle}
          css={styles.content}
        />
      </div>
    </div>
  )
}

export default EmptyFolder
